import { isEmpty } from '@ember/utils'
import type { NormalizedInterval } from 'date-fns'
import type { DrivingTestsTotalsByMonthData } from 'teacher-ui-client/components/giraffe/charts/driving-tests/totals-by-month'
import type { StudentScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type StudentEventsService from 'teacher-ui-client/services/student-events'
import fillMonths from 'teacher-ui-client/utils/student-events/fill-months'

export interface DrivingTestDetailsTotalsByMonthResponse {
  driving_test_details_totals_by_month: {
    month: string
    content_words: number
    letters_and_sounds: number
    sight_words: number
  }[]
}

export async function drivingTestDetailsTotalsByMonth(
  this: StudentEventsService,
  product: LegacyProductRe,
  statsScope: StudentScope,
  period: NormalizedInterval,
): Promise<Nullable<DrivingTestsTotalsByMonthData[]>> {
  if (isEmpty(statsScope.ids)) return null
  const url = this.buildUrl('driving_test_details_totals_by_month', product, statsScope)
  const query = this.buildQuery(statsScope, period)

  const data = await this.fetchData<DrivingTestDetailsTotalsByMonthResponse>(url, query)
  if (!data) return null

  const { driving_test_details_totals_by_month: totalsData } = data
  if (totalsData.length === 0) return null

  return fillMonths(totalsData, period, { content_words: 0, letters_and_sounds: 0, sight_words: 0 })
}
